if (!customElements.get("image-with-text")) {
  customElements.define(
    "image-with-text",
    class imageWithText extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.getAttribute('data-section-id');
        this.dataPopup = this.getAttribute('data-popup');
        let _self = this;

        if(this.dataPopup == "true") {
          let self = this
          // this.querySelector('.image-with-text__heading')?.addEventListener('click', function() {
          //   self.openPopup(self);
          // });
          this.querySelector('.image-with-text__text.rte')?.addEventListener('click', function() {
            self.openPopup(self);
          });
          this.querySelector('.btn-close-popup')?.addEventListener('click', function() {
            self.closePopup(self)
          });
        }
        this.countImage = Number(this.getAttribute('data-count-image'));
        if(this.countImage > 1) {
          this.initSlider(this);
        }

        this.querySelectorAll('.buttonDownload').forEach(button => {
          button.addEventListener('click', function() {
            _self.downloadFile(button);
          })
        })
      }

      downloadFile(button) {
        let url = button.getAttribute('data-url');
        let label = button.getAttribute('data-label');
        fetch(url)
          .then((response) => response.blob())
          .then((blob) => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = label;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
          })
          .catch(console.error);
      }

      initSlider(self) {
        let sectionId = self.sectionId;
        new Swiper(`#swiper-${sectionId}`, {
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          loop: true,
          autoplay: {
            delay: 3000,
          },
          mousewheel: {
            forceToAxis: true,
          },
        });
      }

      openPopup(self) {
        if(self.querySelector('.image-with-text-popup')) {
          self.querySelector('.image-with-text-popup').classList.add('model-open');
        }
        document.querySelector('body').classList.add('not-scroll')
      }

      closePopup(self) {
        if(self.querySelector('.image-with-text-popup')) {
          self.querySelector('.image-with-text-popup').classList.remove('model-open');
        }
        document.querySelector('body').classList.remove('not-scroll')
      }
    }
  );
}